<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
            <div v-if="!loading" class="col-md-8 mb-0">
                <alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>
				<approval-alert-component :hasPendingApproval="bankAccounts.hasPendingApproval"></approval-alert-component>

                <h3 class="tx-color-01 mg-b-10">Bank Account Information</h3>
                <p class="tx-color-03 mg-b-10">
                    Please provide us with your banking details (of a bank domiciled in Ghana) from which you will make your initial
                    investment and to which you would like all sales proceeds, investment returns and dividends
                    to be paid.
                </p>

                <form class="row" @submit.prevent="save">
                    <h5 class="tx-color-01 col-md-12">Bank Account Information for GHS</h5>
					<div class="form-group col-md-6">
						<label>Bank Name</label>
						<bank-selector-component :bank="form[0].bank_id" @change-bank="changeGhsBank" :has-error="form.errors.has('[0].bank_id')" :required="false"></bank-selector-component>
						<has-error :form="form" field="[0].bank_id"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>Branch Name</label>
						<bank-branch-selector-component :bank="form[0].bank_id" :branch="form[0].branch" @change-branch="changeGhsBankBranch" :has-error="form.errors.has('[0].branch')" :required="false"></bank-branch-selector-component>
						<has-error :class="'d-block'" :form="form" field="[0].branch"></has-error>
					</div>
					<div class="form-group col-md-12">
						<label>Account Number</label>
						<input v-model="form[0].account_number" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('[0].account_number') }" placeholder="Enter your account number" :required="form[0].bank_id && form[0].branch">
						<has-error :class="'d-block'" :form="form" field="[0].account_number"></has-error>
					</div>

					<h5 class="tx-color-01 mg-t-30 col-md-12">Bank Account Information for USD</h5>
					<div class="form-group col-md-6">
						<label>Bank Name</label>
						<bank-selector-component :bank="form[1].bank_id" @change-bank="changeUsdBank" :has-error="form.errors.has('[0].bank_id')" :required="false"></bank-selector-component>
						<has-error :class="'d-block'" :form="form" field="[0].bank_id"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>Branch Name</label>
						<bank-branch-selector-component :bank="form[1].bank_id" :branch="form[1].branch" @change-branch="changeUsdBankBranch" :has-error="form.errors.has('[0].bank_id')" :required="false"></bank-branch-selector-component>
						<has-error :class="'d-block'" :form="form" field="[0].branch"></has-error>
					</div>
					<div class="form-group col-md-12">
						<label>Account Number</label>
						<input v-model="form[1].account_number" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('[0].account_number') }" placeholder="Enter your account number" :required="form[0].bank_id && form[0].branch">
						<has-error :form="form" field="[0].account_number"></has-error>
					</div>
					
					<div class="col-12 border-top mt-3">
						<button-component :busy="form.busy" :label="'Save'" :label-loading="'Saving changes...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
					</div>
				</form>
            </div>
        </div>
	</div>
</template>

<style scoped>
</style>

<script>
	export default {
		data() {
			const { external_client_id } = this.$store.getters.company;

			return {
				loading: false,
				error: null,
				accounts: null,
				bankAccounts: null,
				form: new Form([
					{
						account_number: null,
						bank_id: null,
						branch: null,
						type: "GHS",
						external_client_id,
					},
					{
						account_number: null,
						bank_id: null,
						branch: null,
						type: "USD",
						external_client_id,
					},
				]),
			};
		},
		created() {
			this.fetchAccountInformation();
		},

		computed: {
			clientName: function () {
				return this.$store.getters.userFullname;
			},
		},
		watch: {
			$route: "fetchAccountInformation",
		},
		methods: {
			changeGhsBank(bank) {
				this.form[0].bank_id = bank;
			},
			changeGhsBankBranch(branch) {
				this.form[0].branch = branch;
			},
			changeUsdBank(bank) {
				this.form[1].bank_id = bank;
			},
			changeUsdBankBranch(branch) {
				this.form[1].branch = branch;
			},
			fetchAccountInformation() {
				const { external_client_id } = this.$store.getters.company;
				this.error = this.warning = null;
				this.loading = true;

				axios
					.get(`/api/companies/${external_client_id}`)
					.then((response) => {
						this.bankAccounts =
							response.data.data.company.bank_account_information;

						if (!_.isEmpty(this.bankAccounts)) {
							this.form.fill(this.bankAccounts);
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			save() {
				this.form
					.post("/api/bank-accounts")
					.catch(() => {
						this.errors = this.form.errors.get("error");
					})
					.finally(() => {
						window.scrollTo(0, 0);
					});
			},
		},
	};
</script>
